import { SET_ORGANIZATIONS_DATA, REMOVE_ORGANIZATIONS, SET_ORGANIZATION_FILTER, SET_ORG_PAGE_NUMBER, SET_ALL_ORGANIZATION, SET_ORGANIZATION_COUNT } from '../types'

const initialState = {
    organizations: [],
    allOrganizations: [],
    vehicleFilter: null,
    pageNumber: 1,
    orgSelectionCount: 0,
}

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ORGANIZATIONS_DATA:
            return {
                ...state,
                organizations: action.payload,
            }

        case REMOVE_ORGANIZATIONS:
            return {
                organizations: [],
            }
        case SET_ORGANIZATION_FILTER:
            return {
                ...state,
                organizationFilter: action.payload,
            }
        case SET_ALL_ORGANIZATION:
            return {
                ...state,
                allOrganizations: action.payload,
            }
        case SET_ORG_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.payload,
            };
        case SET_ORGANIZATION_COUNT:
            return {
                ...state,
                orgSelectionCount: action.payload,
            };
        // case SET_ORGANIZATION_FILTER:
        //     console.log("Reducer action received:", action);
        //     return {
        //         ...state,
        //         vehicleFilter: action.payload,
        //     }


        default:
            return state
    }
}

export default organizationReducer